import React from 'react';
import { Modal, Tabs } from 'antd';

import RecordBadge, { RecordIdentity } from '../common/RecordBadge';
import QuickAddList from './QuickAddList';
import MultiAddList from './MultiAddList';

/**
 * The Add item modal's "Manage…" door: the quick add and multi add lists in
 * a modal of their own, leading with the collection's identity like every
 * record modal. The lists' stores are the picker's, so a launcher created
 * here is in the picker the moment the modal closes; a multi add edit
 * leaves for its editor page (the modal closes first).
 */
export default function AddItemManagerModal({ open, onClose, onNavigate, collectionId, collection, cardsById, quickAdds, multiAdds }) {
	return (
		<Modal
			open={open}
			onCancel={onClose}
			title="Quick add & Multi add"
			footer={null}
			destroyOnClose
			className="quick-add-manager"
		>
			{collection ? (
				<div className="modal-identity">
					<RecordIdentity
						kicker="Collection"
						badge={<RecordBadge kind="collection" record={collection} title={collection?.name || 'Untitled collection'} />}
					/>
				</div>
			) : null}
			<Tabs
				items={[
					{
						key: 'quick-add',
						label: 'Quick add',
						children: (
							<QuickAddList
								collectionId={collectionId}
								collection={collection}
								cardsById={cardsById}
								store={quickAdds}
							/>
						),
					},
					{
						key: 'multi-add',
						label: 'Multi add',
						children: (
							<MultiAddList
								collectionId={collectionId}
								collection={collection}
								cardsById={cardsById}
								store={multiAdds}
								// Leaving for the editor (or a form's page) closes
								// this modal AND the picker beneath it — the
								// trigger lives in the context bar and outlives
								// the route.
								onNavigate={onNavigate || onClose}
							/>
						),
					},
				]}
			/>
		</Modal>
	);
}
